export const AUTH_TWO_FACTOR_AUTH_REQUEST = 'AUTH_TWO_FACTOR_AUTH_REQUEST';
export const AUTH_TWO_FACTOR_AUTH_SUCCESS = 'AUTH_TWO_FACTOR_AUTH_SUCCESS';
export const AUTH_TWO_FACTOR_AUTH_FAILURE = 'AUTH_TWO_FACTOR_AUTH_FAILURE';

export const AUTH_TWO_FACTOR_AUTH_CODE_REQUEST = 'AUTH_TWO_FACTOR_AUTH_CODE_REQUEST';
export const AUTH_TWO_FACTOR_AUTH_CODE_SUCCESS = 'AUTH_TWO_FACTOR_AUTH_CODE_SUCCESS';
export const AUTH_TWO_FACTOR_AUTH_CODE_FAILURE = 'AUTH_TWO_FACTOR_AUTH_CODE_FAILURE';

export const AUTH_LOGIN_FORM_AUTH_CODE_SUCCESS = 'AUTH_LOGIN_FORM_AUTH_CODE_SUCCESS';

export const RESEND_TWO_FACTOR_AUTH_CODE_REQUEST = 'RESEND_TWO_FACTOR_AUTH_CODE_REQUEST';
export const RESEND_TWO_FACTOR_AUTH_CODE_SUCCESS = 'RESEND_TWO_FACTOR_AUTH_CODE_SUCCESS';
export const RESEND_TWO_FACTOR_AUTH_CODE_FAILURE = 'RESEND_TWO_FACTOR_AUTH_CODE_FAILURE';
